import { hooks } from "./hookactions"
export let DATSearchPaket = { hooks }
